import e from"styled-components";import{theme as r}from"../../../theme.js";const i=e.div`
  border-radius: ${r.radius}px;
  padding: ${r.spacing*4}px;
  background-color: ${r.colors.gray[100]};
  display: grid;
  grid-template-columns: 1fr 1px 1fr;
  align-items: center;
  .wrapper {
    display: flex;
    flex-direction: column;
    justify-content: center;
    widows: 100%;
    text-align: center;
    gap: ${r.spacing}px;
    .label {
      font-size: 12px;
      color: ${r.colors.gray[400]};
      font-weight: 700;
    }
    .value {
      font-size: 16px;
      font-weight: 700;
      color: ${r.colors.gray[900]};
      display: flex;
      align-items: center;
      gap: ${r.spacing*2}px;
      justify-content: center;
    }
  }
  .divider {
    height: 78px;
    background-color: ${r.colors.gray[300]};
  }
`,o=e.div`
  width: 24px;
  height: 24px;
  border-radius: ${r.radius}px;
  background-color: ${r.colors.primary[500]};
  display: flex;
  align-items: center;
  justify-content: center;
  > svg {
    width: 18px;
    height: 18px;
    > g, path {
      fill: ${r.colors.shades[0]};
    }
  }
`;export{i as Container,o as StarContainer};
